"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8310],{

/***/ 28310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTowel = function SvgTowel(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M13.334 2.667h-1V2A1.335 1.335 0 0 0 11.001.667a1.32 1.32 0 0 0-.222.022.33.33 0 0 0-.112-.022H3.001A1.335 1.335 0 0 0 1.667 2v.667h-1a.333.333 0 1 0 0 .666h1V11a.333.333 0 0 0 .334.333h8a.334.334 0 0 0 .333-.333V9.333h1.667A.333.333 0 0 0 12.334 9V3.333h1a.333.333 0 1 0 0-.666ZM11.667 2v.667h-1.333V2a.667.667 0 1 1 1.333 0ZM2.334 5.902c1.548-.57 2.449-.37 3.566-.108.815.218 1.655.335 2.499.347a9.958 9.958 0 0 0 1.268-.096v1.33a8.75 8.75 0 0 1-3.615-.23c-1.08-.254-2.113-.485-3.718.051V5.902Zm0-3.902a.668.668 0 0 1 .667-.667h6.852c-.12.202-.184.432-.186.667v3.376a8.75 8.75 0 0 1-3.615-.231c-1.08-.254-2.113-.485-3.718.051V2Zm7.333 8.667H2.334V7.902c1.548-.57 2.449-.37 3.566-.108.815.218 1.655.335 2.499.347a9.958 9.958 0 0 0 1.268-.096v2.622Zm2-2h-1.333V3.333h1.333v5.334Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgTowel);

/***/ })

}]);